import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Menu, X, Bitcoin } from 'lucide-react';
import { Button } from './ui/button';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const user = localStorage.getItem('user');
    setIsLoggedIn(!!user);

    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    setIsLoggedIn(false);
    navigate('/');
  };

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ${
      scrolled 
        ? 'bg-white shadow-md border-b border-gray-200' 
        : 'bg-white/95 backdrop-blur-sm border-b border-gray-100'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center space-x-2">
            <Bitcoin className="h-8 w-8 text-[#006AFF]" />
            <span className="text-2xl font-bold text-[#2A2A33]">AssumeRate</span>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-[#2A2A33] hover:text-[#006AFF] transition-colors font-medium">
              Home
            </Link>
            <Link to="/marketplace" className="text-[#2A2A33] hover:text-[#006AFF] transition-colors font-medium">
              Marketplace
            </Link>
            <Link to="/real-cre" className="text-[#2A2A33] hover:text-[#006AFF] transition-colors font-medium">
              CRE
            </Link>
            <Link to="/calculator" className="text-[#2A2A33] hover:text-[#006AFF] transition-colors font-medium">
              Calculator
            </Link>
            <Link to="/how-it-works" className="text-[#2A2A33] hover:text-[#006AFF] transition-colors font-medium">
              Process Flow
            </Link>
            {isLoggedIn ? (
              <>
                <Link to="/dashboard" className="text-[#2A2A33] hover:text-[#006AFF] transition-colors font-medium">
                  Dashboard
                </Link>
                <Button onClick={handleLogout} variant="outline" className="border-[#006AFF] text-[#006AFF] hover:bg-[#006AFF] hover:text-white">
                  Logout
                </Button>
              </>
            ) : (
              <>
                <Link to="/login">
                  <Button variant="outline" className="border-[#006AFF] text-[#006AFF] hover:bg-[#006AFF] hover:text-white">
                    Sign In
                  </Button>
                </Link>
                <Link to="/signup">
                  <Button className="bg-[#006AFF] hover:bg-[#0055CC] text-white">
                    Get Started
                  </Button>
                </Link>
              </>
            )}
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button onClick={() => setIsOpen(!isOpen)} className="text-[#2A2A33] hover:text-[#006AFF]">
              {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-white border-t border-gray-200 shadow-lg">
          <div className="px-2 pt-2 pb-3 space-y-1">
            <Link to="/" className="block px-3 py-2 text-[#2A2A33] hover:text-[#006AFF] hover:bg-gray-50 rounded-md font-medium">
              Home
            </Link>
            <Link to="/marketplace" className="block px-3 py-2 text-[#2A2A33] hover:text-[#006AFF] hover:bg-gray-50 rounded-md font-medium">
              Marketplace
            </Link>
            <Link to="/real-cre" className="block px-3 py-2 text-[#2A2A33] hover:text-[#006AFF] hover:bg-gray-50 rounded-md font-medium">
              CRE
            </Link>
            <Link to="/calculator" className="block px-3 py-2 text-[#2A2A33] hover:text-[#006AFF] hover:bg-gray-50 rounded-md font-medium">
              Calculator
            </Link>
            <Link to="/how-it-works" className="block px-3 py-2 text-[#2A2A33] hover:text-[#006AFF] hover:bg-gray-50 rounded-md font-medium">
              Process Flow
            </Link>
            {isLoggedIn ? (
              <>
                <Link to="/dashboard" className="block px-3 py-2 text-[#2A2A33] hover:text-[#006AFF] hover:bg-gray-50 rounded-md font-medium">
                  Dashboard
                </Link>
                <button onClick={handleLogout} className="block w-full text-left px-3 py-2 text-[#2A2A33] hover:text-[#006AFF] hover:bg-gray-50 rounded-md font-medium">
                  Logout
                </button>
              </>
            ) : (
              <>
                <Link to="/login" className="block px-3 py-2 text-[#2A2A33] hover:text-[#006AFF] hover:bg-gray-50 rounded-md font-medium">
                  Sign In
                </Link>
                <Link to="/signup" className="block px-3 py-2 text-[#006AFF] hover:bg-gray-50 rounded-md font-medium">
                  Get Started
                </Link>
              </>
            )}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
